export default __webpack_public_path__ + "static/media/img_step_situation05.c23dc2f9.jpg";